import PropTypes from 'prop-types';
import styles from './FJAIVideoEffectUploadControl.module.less';
import { AI_EFFECTS_TYPES, UPLOAD_IMG_TO_VIDEO_EFFECT } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput.jsx';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJTextarea from '../../../../common/components/FJTextarea/FJTextarea.jsx';
import FJImageUpload from '../../../../common/components/FJUpload/FJImageUpload/FJImageUpload.jsx';
import FJVideoUpload from '../../../../common/components/FJUpload/FJVideoUpload/FJVideoUpload.jsx';
import UploadCircleIcon from '../../../../assets/svg/upload-circle.svg?react';
import FJUploadLeftIcon from '../../../../assets/svg/aiGeneratorVideo/left.svg?react';
import FJUploadRightIcon from '../../../../assets/svg/aiGeneratorVideo/right.svg?react';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab.jsx';
import FJPeople32Icon from '../../../../assets/svg/aiGeneratorVideo/people-32px.svg?react';
import FJPeople24Icon from '../../../../assets/svg/aiGeneratorVideo/people-24px.svg?react';
import FJDancePresetList from './FJDancePresetList.jsx';
import { CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS } from '../../../../config/dataConfig/FJGenerateData.js';
import FJGeneratePrivacySettingsContainer from '../container/FJGeneratePrivacySettingsContainer.jsx';
const FJAIVideoEffectUploadControl = props => {
    const {
        freeNumCreation,
        textValue,
        onTextValueChange,
        videoEffectUploadImageInfo,
        videoEffectUploadTwoImageInfo,
        taskStatus,
        videoEffectCredit,
        isProjectLoading,
        onUpload,
        onDelete,
        onGenerate,
        currentInfo,
        onChangeMenuIndex,
        imageTypeIndex,
        openMediaLibrary,
        dancePresetList,
        videoEffectUploadVideoInfo,
        onDeleteVideo,
        onDancePresetItemClick,
    } = props;
    const [isDraggingFile, setIsDraggingFile] = useState();
    const menuTabList = useRef([{ text: 'upload-two-photos' }, { text: 'upload-a-photo' }]);
    const { list = [] } = currentInfo;
    const isShowTab = list.length === 2;

    useEffect(() => {
        onChangeMenuIndex(0);
        onTextValueChange(undefined, '');
    }, [currentInfo]);

    const showUsageDetail = useMemo(() => {
        const showList = ['dancing', 'mimic-motion', 'character-swap'];
        return showList.includes(currentInfo?.key);
    }, [currentInfo]);
    const footerHeight = useMemo(() => {
        let _height = isShowTab ? 58 : 0;

        list.forEach((item, index) => {
            if (imageTypeIndex === index) {
                if (item.imgType === 'DOUBLE') {
                    _height = _height + 132;
                } else if (item.imgType === 'SINGLE' && !item.needs_prompt) {
                    _height = _height + 92;
                } else if (item.imgType === 'SINGLE' && item.needs_prompt) {
                    _height = _height + 132;
                }
            }
        });

        return isShowTab ? _height : 'auto';
    }, [list, isShowTab, imageTypeIndex]);

    return (
        <div className={styles.footer}>
            <div className={styles.footer_content} style={{ height: footerHeight }}>
                <div className={styles.footerTitle}>{FJLocalStore._('upload')}</div>
                {isShowTab && (
                    <FJMenuTab
                        list={menuTabList.current}
                        curIndex={imageTypeIndex}
                        onChange={onChangeMenuIndex}
                        style={{ marginBottom: '16px' }}
                    />
                )}

                {list.map((item, index) => {
                    let _videoEffectType = AI_EFFECTS_TYPES.ONE_PIC;
                    if (item.imgType === 'DOUBLE') {
                        _videoEffectType = AI_EFFECTS_TYPES.TWO_PIC;
                    } else if (item.imgType === 'SINGLE' && !item.needs_prompt) {
                        _videoEffectType = AI_EFFECTS_TYPES.ONE_PIC;
                    } else if (item.imgType === 'SINGLE' && item.needs_prompt) {
                        _videoEffectType = AI_EFFECTS_TYPES.ONE_PIC_AND_PROMPTS;
                    } else if (item.imgType === 'VIDEO_AND_PIC') {
                        _videoEffectType = AI_EFFECTS_TYPES.VIDEO_AND_PIC;
                    }

                    if (imageTypeIndex !== index) {
                        return null;
                    }

                    const singleUploadText = item.upload_text
                        ? item.upload_text
                        : list.length > 1
                          ? 'upload-a-photo'
                          : 'upload-image';

                    return (
                        <Fragment key={index}>
                            {AI_EFFECTS_TYPES.ONE_PIC === _videoEffectType && (
                                <>
                                    <FJImageInput
                                        uploadImageInfo={videoEffectUploadImageInfo}
                                        isDraggingFile={isDraggingFile}
                                        isDelete={true}
                                        onDelete={onDelete}
                                        acceptFile={UPLOAD_IMG_TO_VIDEO_EFFECT}
                                        openMediaLibrary={openMediaLibrary}
                                        setIsDraggingFile={setIsDraggingFile}
                                        uploadImg={onUpload}
                                        style={{ height: 60 }}
                                        previewClassName={styles.preview_box}
                                        uploadText={singleUploadText}
                                        uploadTextClassName={isShowTab ? styles.tab_upload_text : styles.upload_text}
                                        reupload_text={FJLocalStore._('replace')}
                                        previewImageStyle={{ left: '559px' }}
                                    />
                                </>
                            )}
                            {AI_EFFECTS_TYPES.ONE_PIC_AND_PROMPTS === _videoEffectType && (
                                <div className={styles.img_and_text}>
                                    <FJImageUpload
                                        defaultIcon={<UploadCircleIcon />}
                                        uploadText='upload'
                                        style={{ width: '100px', height: '100px' }}
                                        acceptFile={UPLOAD_IMG_TO_VIDEO_EFFECT}
                                        uploadImg={onUpload}
                                        openMediaLibrary={openMediaLibrary}
                                        onDelete={onDelete}
                                        imageInfo={videoEffectUploadImageInfo}
                                        previewImageStyle={{ left: '559px' }}
                                    />
                                    <FJTextarea
                                        placeholder={FJLocalStore._('please-describe-the-subject-motion-details')}
                                        text={textValue}
                                        onChange={onTextValueChange}
                                        maxLength={2000}
                                        className={styles.text_box}
                                    />
                                </div>
                            )}

                            {AI_EFFECTS_TYPES.TWO_PIC === _videoEffectType && (
                                <div className={styles.two_img}>
                                    <FJImageUpload
                                        defaultIcon={<FJUploadLeftIcon />}
                                        style={{ width: '210px', height: '100px' }}
                                        uploadText='left-person'
                                        acceptFile={UPLOAD_IMG_TO_VIDEO_EFFECT}
                                        uploadImg={file => {
                                            onUpload(file, 0);
                                        }}
                                        onDelete={() => {
                                            onDelete(0);
                                        }}
                                        openMediaLibrary={() => {
                                            openMediaLibrary(0);
                                        }}
                                        imageInfo={videoEffectUploadTwoImageInfo[0]}
                                        uploadTextClassName={isShowTab ? styles.upload_color : ''}
                                        previewImageStyle={{ left: '559px' }}
                                    />
                                    <FJImageUpload
                                        defaultIcon={<FJUploadRightIcon />}
                                        style={{ width: '210px', height: '100px' }}
                                        uploadText='right-person'
                                        acceptFile={UPLOAD_IMG_TO_VIDEO_EFFECT}
                                        uploadImg={file => {
                                            onUpload(file, 1);
                                        }}
                                        onDelete={() => {
                                            onDelete(1);
                                        }}
                                        openMediaLibrary={() => {
                                            openMediaLibrary(1);
                                        }}
                                        imageInfo={videoEffectUploadTwoImageInfo[1]}
                                        uploadTextClassName={isShowTab ? styles.upload_color : ''}
                                        previewImageStyle={{ left: '559px' }}
                                    />
                                </div>
                            )}

                            {AI_EFFECTS_TYPES.VIDEO_AND_PIC === _videoEffectType && (
                                <div className={styles.two_img}>
                                    <FJImageUpload
                                        defaultIcon={<FJPeople32Icon />}
                                        style={{ width: '210px', height: '100px' }}
                                        uploadText='upload-person'
                                        acceptFile={UPLOAD_IMG_TO_VIDEO_EFFECT}
                                        uploadImg={onUpload}
                                        onDelete={onDelete}
                                        openMediaLibrary={openMediaLibrary}
                                        imageInfo={videoEffectUploadImageInfo}
                                        uploadTextClassName={isShowTab ? styles.upload_color : ''}
                                        leftBottomIcon={<FJPeople24Icon />}
                                        previewImageStyle={{ left: '559px' }}
                                    />
                                    <FJVideoUpload
                                        style={{ width: '210px', height: '100px' }}
                                        uploadText='upload-video'
                                        acceptFile={CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS}
                                        autoPreview={true}
                                        uploadFile={file => {
                                            onUpload(file, 0, true);
                                        }}
                                        onDelete={() => {
                                            onDeleteVideo(0);
                                        }}
                                        openMediaLibrary={() => {
                                            openMediaLibrary(0, 'VIDEO', CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS);
                                        }}
                                        mediaInfo={videoEffectUploadVideoInfo}
                                        uploadTextClassName={isShowTab ? styles.upload_color : ''}
                                        previewVideoStyle={{ left: '559px', bottom: '20px', top: 'auto' }}
                                    />
                                </div>
                            )}
                            {currentInfo.name === 'dancing' && (
                                <FJDancePresetList
                                    dancePresetList={dancePresetList}
                                    onItemClick={onDancePresetItemClick}
                                />
                            )}
                        </Fragment>
                    );
                })}
            </div>
            <div className={styles.footer_box}>
                <FJGeneratePrivacySettingsContainer />
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={false}
                    useCredit={videoEffectCredit}
                    isProjectLoading={isProjectLoading}
                    style={{ flex: 1 }}
                    isShowUsageDetail={showUsageDetail}
                />
            </div>
        </div>
    );
};
FJAIVideoEffectUploadControl.propTypes = {
    videoEffectSelectItem: PropTypes.object,
    freeNumCreation: PropTypes.number,
    textValue: PropTypes.string,
    onTextValueChange: PropTypes.func,
    videoEffectUploadImageInfo: PropTypes.object,
    videoEffectUploadTwoImageInfo: PropTypes.array,
    taskStatus: PropTypes.string,
    videoEffectCredit: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    onUpload: PropTypes.func,
    onDelete: PropTypes.func,
    onGenerate: PropTypes.func,
    currentInfo: PropTypes.object,
    imageTypeIndex: PropTypes.number,
    onChangeMenuIndex: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    dancePresetList: PropTypes.array,
    videoEffectUploadVideoInfo: PropTypes.object,
    onDeleteVideo: PropTypes.func,
    onDancePresetItemClick: PropTypes.func,
};
export default FJAIVideoEffectUploadControl;
